// @flow
import BadgeComponent from './badge';

export default BadgeComponent;
